import get from "lodash/get"
import set from "lodash/set"
import setWith from "lodash/setWith"
import Vue from "vue"

export const defaults = function (target, ...sources) {
    sources.forEach(source => {
        Object.keys(source).forEach(key => {
            if (target[key] === undefined) {
                target[key] = source[key]
            }
        })
    })

    return target
}

export const defaultsNull = function (target, ...sources) {
    sources.forEach(source => {
        Object.keys(source).forEach(key => {
            if (target[key] == null) {
                target[key] = source[key]
            }
        })
    })

    return target
}

export const clearProperties = function (obj) {
    if (!obj) return obj
    Object.keys(obj).forEach(key => delete obj[key])
    return obj
}

export const copyDeep = function (obj) {
    if (!obj) return obj
    return JSON.parse(JSON.stringify(obj))
}

export const getProperty = function (obj, path, defaultValue) {
    if (!path || path === "$it") return obj
    return get(obj, path, defaultValue)
}

export const setProperty = function (obj, path, value, customizer) {
    if (customizer) return setWith(obj, path, value, customizer)
    return set(obj, path, value)
}

export const fillProperty = function (root, path, value, name = null) {
    if (!name) {
        const index = path.lastIndexOf(".")
        if (index < 0) {
            name = path
        } else {
            name = path.substring(index + 1)
        }
    }

    let immediateParent = root
    setProperty(root, path, value, (value, key, parent) => {
        if (value == null) {
            if (Array.isArray(parent)) {
                value = []
            } else {
                value = {}
            }

            Vue.set(parent, key, value)
        }

        immediateParent = value
        return value
    })

    // The following is done to ensure the property is reactive
    delete immediateParent[name]
    Vue.set(immediateParent, name, value)
}

export const isPromiseLike = function (obj) {
    return typeof obj?.then === "function"
}
